/**
 * Permission utilities for checking user access levels
 */

export interface UserProfile {
  id: string;
  email: string;
  organizationId: string;
  [key: string]: any;
}

export interface OrganizationStaff {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  isHeadOfOrganization: boolean;
  isAdmin: boolean;
}

/**
 * Check if the current user can export PDFs
 * Only admins and heads of organization have this permission
 */
export function canExportPDF(
  currentUser: UserProfile | null | undefined,
  organizationStaff: OrganizationStaff[] | null | undefined
): boolean {
  if (!currentUser || !organizationStaff) {
    return false;
  }

  // Get user's email from various possible locations
  const userEmail = currentUser.email || (currentUser as any).data?.email;
  
  if (!userEmail) {
    return false;
  }

  // Find the staff record for this user
  const staffRecord = organizationStaff.find(staff => staff.email === userEmail);
  
  if (!staffRecord) {
    return false;
  }

  // Check if user is admin or head of organization
  return staffRecord.isAdmin || staffRecord.isHeadOfOrganization;
}

/**
 * Get the user's role description for display purposes
 */
export function getUserRole(
  currentUser: UserProfile | null | undefined,
  organizationStaff: OrganizationStaff[] | null | undefined
): string {
  if (!currentUser || !organizationStaff) {
    return 'Unknown';
  }

  const userEmail = currentUser.email || (currentUser as any).data?.email;
  
  if (!userEmail) {
    return 'Unknown';
  }

  const staffRecord = organizationStaff.find(staff => staff.email === userEmail);
  
  if (!staffRecord) {
    return 'Unknown';
  }

  if (staffRecord.isHeadOfOrganization) {
    return 'Head of Organization';
  }
  
  if (staffRecord.isAdmin) {
    return 'Administrator';
  }
  
  return 'Staff Member';
}
